import { validate as emailValidatorCheck } from "email-validator";

/** RFC 5321 max email length — reject longer before library call (bounded work). */
const MAX_EMAIL_LENGTH = 254;

/** Validate email format using `email-validator` (RFC-oriented, same as hers consultation). */
export function isValidEmail(email: string): boolean {
  if (!email || email.length > MAX_EMAIL_LENGTH) return false;
  return emailValidatorCheck(email);
}

/** Trim and lowercase an email address. */
export function sanitizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/**
 * Parse and validate an email for auth: trim, lowercase, validate format.
 * Returns the sanitized email if valid, or null.
 */
export function parseEmail(input: unknown): string | null {
  if (typeof input !== "string") return null;
  const s = sanitizeEmail(input);
  if (!s || !isValidEmail(s)) return null;
  return s;
}
